import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve relative asset urls ("/api/files/...") against backend origin.
export const resolveUrl = (url) => {
  if (!url) return url;
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
};
